import { Input, InputProps, Form } from "antd";
import { FormItemProps } from "antd/lib/form/FormItem";
import { useTranslations } from "../../../translations/translations";

interface Props extends FormItemProps {
	inputProps?: InputProps;
}

const CityFormItem = ({ inputProps, ...props }: Props) => {
	const t = useTranslations();

	return (
		<Form.Item
			label={t.city}
			{...props}
			rules={[
				{
					type: "string",
					max: 30,
					message: t.fieldInvalid,
				},
				...(props.required
					? [
							{
								required: true,
								message: t.fieldRequired,
							},
					  ]
					: []),
				...(props.rules || []),
			]}
			validateFirst
		>
			<Input maxLength={30} placeholder={t.cityPlaceholder} {...inputProps} />
		</Form.Item>
	);
};

export default CityFormItem;
